module.exports = __webpack_public_path__ + "media/images/potatoes-597d4219f75b67e80ee73fc5c2e2e8a9.png";